// src/screens/recruit/RecruitScreen.js
// 48차: AppHeader showBack 시 ‹ 뒤로 표기 (AppHeader 기본 backArrow 사용)
//       WaitingList 진입 시 뒤로가기 정상 표시
// 51차: 색 theme.js 단일화 — C 팔레트를 COLORS 참조로 (초록/빨강/주황/파랑 통일)
// 73차: loading 중 화면에도 AppHeader 유지 — 로딩 스피너만 뜨는 동안 헤더가
// 사라져 "이 탭엔 헤더가 없다"처럼 보이던 문제 수정
// 74차: 검색/필터/작성/초기화 레이아웃 정리 — "작성" 버튼을 검색창 옆으로 옮기고,
// "초기화" 버튼을 필터 활성 여부에 따라 등장/소실시키던 것 대신 위치를 고정하고
// 비활성 상태(흐리게)만 토글하도록 변경 (필터 걸 때마다 작성 버튼 옆에 X가 툭
// 튀어나오는 것처럼 보이던 문제)
// 74차: 카드 목록 작성자명 옆 [크루명] 태그 표시 (recruit.authorCrewName 스냅샷)
// 74차: navigation.canGoBack()이 이 화면(탭) 하나가 아니라 상위 네비게이터 전체(로그인
// 모달 스택 등)까지 훑어서 판단하는 바람에, 앱을 조금만 돌아다녀도 "뒤로가기 가능"으로
// 잘못 판정돼 모집 탭에 UNLOCK 로고 대신 "‹ 뒤로"만 계속 뜨던 버그 수정. 애초에 이걸
// 구분하려던 대상(WaitingList 스택 화면)은 아무도 navigate하지 않는 죽은 라우트였음 —
// canGoBack 로직을 걷어내고 항상 로고만 표시하도록 단순화
// 74차: 비회원 전면 차단 화면 제거 — 모집 게시판 조회는 비회원도 가능하게 하고(firestore.rules
// 상 이미 공개 읽기 허용), "작성"/"참여 신청" 등 실제 행동을 할 때만 로그인 유도(RecruitDetailScreen.js/
// RecruitWriteGuard가 이미 그렇게 처리 중이라 이 화면에서 별도 가드 추가 불필요)
// 74차: MyPageScreen "내 모집 관리" → navigate('WaitingList', {showBack:true})가 실제로
// 쓰이고 있어(이전 세션의 "죽은 라우트" 판단은 오판), route.params.showBack 기반으로
// 뒤로가기 버튼 복원 (canGoBack() 재도입은 금지 — 위에서 이미 그 버그를 걷어냈음)
// 75차: 지역 필터가 시/도 단위뿐이었음 — 글 작성 시 이미 저장되는 상세지역(구/동,
// constants/index.js의 SUB_REGIONS)을 필터에도 노출. 난이도 필터가 raw 영문값
// ("easy" 등)을 그대로 표시하던 것도 한글 라벨(DIFFICULTY_LABELS)로 수정.
// 77차: design 폴더 팀원 모집(목록) 화면 스펙 적용 — D-DAY를 공용 <DDayBadge>로,
// "작성" 버튼을 골드 그라디언트 사각 아이콘 버튼으로, "빈자리만" 토글 선택 상태를
// 골드 그라디언트 fill로, 카드 radius를 스펙값(16)으로 조정. 필터/뱃지 등 기존
// 데이터 로직·정보(내 글/신청중/참가중 등)는 그대로 유지.
// 78차: 카드 세로 높이 축소 — 이미지가 상단에 크게(140) 깔리고 본문이 6단으로 쌓여
// 목록 가독성이 떨어진다는 신고로, 좌측 소형 썸네일(76x76)+우측 압축 정보의 가로
// 레이아웃으로 재구성. 진행바 삭제, 하단 안내는 한 줄 요약으로 압축(정보 손실 없이
// numberOfLines=1로 말줄임 처리해 카드 높이를 항목 내용과 무관하게 고정).

// 78차 32차: 검색어 지우기(✕) 버튼에 accessibilityLabel 추가(접근성 라벨 전수 점검)
import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  View, Text, ScrollView, TouchableOpacity,
  StyleSheet, ActivityIndicator, RefreshControl, TextInput, Pressable, Modal,
  useWindowDimensions,
} from 'react-native';
// 78차 37차: 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import { useNavigation, useFocusEffect, useRoute } from '@react-navigation/native';
import { collection, getDocs, query, where, doc, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { isConfirmedMinorBirth, todayStr } from '../../utils/dateUtils';
import { showAlert } from '../../components/common/AppAlert';
import AppHeader from '../../components/common/AppHeader';
import { COLORS, GRADIENTS } from '../../constants/theme';
import { SUB_REGIONS, GENRES as MASTER_GENRES, REGIONS as MASTER_REGIONS, getDifficultyLabel, splitGenres } from '../../constants';
import { DDayBadge } from '../../components/common/Buttons';
import { LocationIcon, GenreIcon, EditIcon, MenuEscapeIcon, IconLabel, RecruitDifficultyGaugeIcon, EmptySearchResultIcon, CancelIcon, CheckmarkIcon, StarIcon, CalendarCheckIcon, PeopleIcon, ViewsIcon, HourglassIcon, TrendingUpIcon, MenuBellIcon } from '../../components/common/Icons';

const C = {
  bg:COLORS.bg, surface:COLORS.surface, card:COLORS.surface2,
  border:COLORS.border, gold:COLORS.gold,
  goldBg:COLORS.goldBg, goldBdr:COLORS.goldBorder,
  text:COLORS.text, textSec:COLORS.textSec,
  muted:COLORS.textMuted, success:COLORS.green,
  danger:COLORS.red, warning:COLORS.orange, info:COLORS.blue,
};
const ON_GOLD = COLORS.onGold;
const RADIUS = { sm:8, md:12 };
const SHADOW = { card:{ shadowColor:'#000', shadowOffset:{width:0,height:2}, shadowOpacity:0.3, shadowRadius:4, elevation:3 } };
// 80차 계속: [버그 수정] 이 화면 전용 지역 목록이 constants/index.js의 REGIONS(80차
// 계속에서 18개로 확장됨)와 어긋난 채(10개, 인천/울산/세종/충북/충남/전북/전남/경북/
// 경남/제주 누락) 하드코딩 중복돼 있었음 — 위 GENRES와 동일한 형제 드리프트 버그, 마스터
// 목록 참조로 교체("전체" 필터 옵션만 이 화면에서 추가).
const REGIONS      = ['전체', ...MASTER_REGIONS];
// 78차 45차: 이 화면 전용 목록이 constants/index.js의 GENRES와 어긋나(코미디/어드벤처/
// 드라마/감성 누락) 있어 마스터 목록 참조로 교체("전체" 필터 옵션만 이 화면에서 추가)
const GENRES       = ['전체', ...MASTER_GENRES];
const DIFFICULTIES = ['전체','easy','normal','hard','expert'];
// 80차 후속: 방탈출/체험형 모집글 구분 필터
const FORMATS = [
  { value:'전체', label:'전체' },
  { value:'room', label:'방탈출' },
  { value:'show', label:'체험형' },
];
// 75차: 필터 버튼이 이 값들을 그대로 텍스트로 찍고 있어("easy" 등 raw 영문값 노출) —
// 78차 39차: 로컬 DIFFICULTY_LABELS 삭제 — constants/index.js의 getDifficultyLabel로 공용화
// (easy/normal/hard/expert 4단계는 그걸 쓰고, 이 화면 전용 "전체" 옵션만 아래에서 별도 처리)
const difficultyLabelFor = (d) => (d === '전체' ? '전체' : getDifficultyLabel(d));

function Badge({ label, color }) {
  return (
    <View style={{ borderRadius:20, paddingHorizontal:10, paddingVertical:3, borderWidth:1, borderColor:color }}>
      <Text style={{ fontSize:11, fontWeight:'600', color }}>{label}</Text>
    </View>
  );
}

export default function RecruitScreen() {
  const navigation = useNavigation();
  const route      = useRoute();
  const { width }  = useWindowDimensions();

  const { user, profile, isLoggedIn, loading: authLoading } = useAuth();
  // 79차: [정리] 관리자(super/store) 전용 조회모드(필터/배너/작성버튼 숨김)를 통째로
  // 제거 — StoreAdminTabNavigator/SuperAdminTabNavigator 둘 다 "모집" 탭이 없고,
  // 이 화면으로 가는 유일한 다른 경로(MyPageScreen "내 모집 관리")도 관리자에겐
  // {!isAdmin}으로 숨겨져 있어, 이 분기 자체가 애초에 어느 역할로도 도달 불가능한
  // 죽은 코드였음(fork 발견 → 실기기 검증으로 확인). 매장/총관리자는 모집 게시판에
  // 관여할 실익이 없다고 판단(승인 등 실제 조치는 작성자 본인만 함, 수요 파악은
  // 이미 예약 통계로, 콘텐츠 문제는 이미 신고 경로로 커버됨)해 진입로를 되살리는
  // 대신 이 화면 쪽 코드를 정리하는 쪽으로 결정.
  // 74차: MyPageScreen "내 모집 관리"가 실제로 navigate('WaitingList', {showBack:true})를
  // 호출하고 있었음(이전 세션 노트의 "아무도 안 씀" 판단은 이 지점을 놓친 것) — 뒤로 갈
  // 방법이 없던 문제를 route.params 기반으로 수정(canGoBack() 재도입은 위 버그를 다시 부름)
  const showBack = route.params?.showBack === true;
  // 78차: "내 모집 관리"는 WaitingList 라우트로만 진입하고(showBack=true인 유일한 경로),
  // 지금까지 라벨과 달리 전체 게시판을 그대로 보여주고 있었음 — 내가 쓴 글(uid 일치) +
  // 내가 참여/신청한 글(participants·pendingParticipants에 내 uid 포함)만 걸러서 보여줌.
  const mineOnly = showBack;

  const [recruits,             setRecruits]             = useState([]);
  const [loading,              setLoading]              = useState(true);
  const [refreshing,           setRefreshing]           = useState(false);
  const [searchQuery,          setSearchQuery]          = useState('');
  const [filterRegion,         setFilterRegion]         = useState('전체');
  const [filterSubRegion,      setFilterSubRegion]      = useState('전체'); // 75차: 구/동 단위 필터
  const [filterGenre,          setFilterGenre]          = useState('전체');
  const [filterDifficulty,     setFilterDifficulty]     = useState('전체');
  // 80차 계속: 기본값을 '전체'→'room'(방탈출)으로 변경 — 실사용 모집글 대부분이
  // 방탈출이라, 처음 진입 시 체험형까지 섞여 보이는 것보다 방탈출 기본노출이 더 자연스럽다는
  // 요청(필터 순서를 형식 필터가 맨 앞으로 오도록 재배치한 것과 짝).
  const [filterFormat,         setFilterFormat]         = useState('room'); // 80차 후속: 방탈출/체험형 구분
  const [onlyAvailable,        setOnlyAvailable]        = useState(false);
  const [showRegionPicker,     setShowRegionPicker]     = useState(false);
  const [showGenrePicker,      setShowGenrePicker]      = useState(false);
  const [showDifficultyPicker, setShowDifficultyPicker] = useState(false);
  const [showFormatPicker,     setShowFormatPicker]     = useState(false);

  // 80차 계속: 관심 지역·장르 알림 설정 — 새 모집글이 뜰 때 알림받고 싶은 조건을
  // 유저가 직접 선택(추론이 아니라 명시적 opt-in). 실제 매칭 알림은 새 CF(onRecruitCreated,
  // functions/index.js)가 담당 — 결제(빌링) 복구 전엔 배포가 안 돼 있어 저장은 되지만
  // 알림 자체는 아직 안 감(2026-09-25 결제 확인 후 배포 예정).
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [notifyRegion, setNotifyRegion] = useState(profile?.notifyRecruitRegion || null);
  const [notifyGenre,  setNotifyGenre]  = useState(profile?.notifyRecruitGenre || null);

  // 80차 계속: "나와 잘 맞는 모집" — HomeScreen.js가 이미 쓰는 방식(본인 완료기록에서
  // splitGenres로 다중장르 분리 후 최빈값)과 동일한 계산을 여기서도 수행. 서버 집계가
  // 아니라 본인 소유 reservations만 조회하는 거라 CF 불필요, 로그인 유저 본인만 대상.
  const [favoriteGenre, setFavoriteGenre] = useState(null);
  useEffect(() => {
    if (!user?.uid) { setFavoriteGenre(null); return; }
    getDocs(query(collection(db, 'reservations'), where('uid', '==', user.uid)))
      .then(snap => {
        const genreCount = {};
        snap.docs.forEach(d => {
          const r = d.data();
          if (r.cancelled || !r.date) return;
          splitGenres(r.genre).forEach(g => { genreCount[g] = (genreCount[g] || 0) + 1; });
        });
        const top = Object.entries(genreCount).sort((a, b) => b[1] - a[1])[0];
        setFavoriteGenre(top ? top[0] : null);
      })
      .catch(() => setFavoriteGenre(null));
  }, [user?.uid]);

  // 79차: 목록을 빠르게 나갔다 다시 들어오면 이전 포커스의 loadRecruits()가 늦게
  // 응답해 최신 목록을 오래된 것으로 덮어쓸 수 있었음 — activeRef로 이전 포커스 세션의
  // setState만 무시.
  const activeRef = useRef(true);
  const loadRecruits = useCallback(async () => {
    // 74차: 비회원도 모집 게시판을 조회는 할 수 있도록 — firestore.rules에서 recruits는
    // 이미 allow list/get: if true라 읽기 권한은 문제없음. 참여/작성 등 "행동"만 각자
    // 위치에서 로그인 검사(RecruitDetailScreen, RecruitWriteGuard)
    if (authLoading) { if (activeRef.current) setLoading(false); return; }
    try {
      // 오늘 fork 재검토(Firestore 읽기비용 전수점검)로 발견/수정: 여기가 필터 없이
      // recruits 컬렉션 전체(마감·기한지남 옛 글까지 전부)를 매번 읽어오고 있었음 —
      // 일반 모집탭(mineOnly 아님)은 애초에 지난 날짜 글을 안 보여주므로(아래 filtered의
      // isExpired), 그 컷오프를 쿼리 단계로 당겨와 읽는 문서 수 자체를 줄임. 정상 생성
      // 경로는 scheduledDate가 항상 있어(RecruitWriteScreen.js) 안전 — "내 모집 관리"
      // (mineOnly)는 지난 이력도 계속 봐야 해서 그대로 전체 스캔 유지.
      const q = mineOnly
        ? collection(db, 'recruits')
        : query(collection(db, 'recruits'), where('scheduledDate', '>=', todayStr()));
      const snap = await getDocs(q);
      let list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      // 80차 후속: 확인된 미성년자에게 19금 모집글 목록 노출 차단(비회원/생년월일
      // 미등록은 그대로 노출 — productService.isVisibleToViewer와 동일한 정책)
      if (isConfirmedMinorBirth(profile?.birth)) {
        list = list.filter(r => !r.isAdultOnly);
      }
      const toMs = (v) => {
        if (!v) return 0;
        if (typeof v.toMillis === 'function') return v.toMillis();
        if (typeof v === 'string') return new Date(v).getTime() || 0;
        return 0;
      };
      const now = Date.now();
      list.sort((a, b) => {
        const aBoost = a.boostedUntil ? toMs(a.boostedUntil) > now : false;
        const bBoost = b.boostedUntil ? toMs(b.boostedUntil) > now : false;
        if (aBoost !== bBoost) return aBoost ? -1 : 1;
        return toMs(b.createdAt) - toMs(a.createdAt);
      });
      if (!activeRef.current) return;
      setRecruits(list);
    } catch (e) { if (activeRef.current) console.error('[RecruitScreen]', e); }
    finally { if (activeRef.current) setLoading(false); }
  }, [isLoggedIn, authLoading, profile?.birth, mineOnly]);

  useFocusEffect(useCallback(() => {
    activeRef.current = true;
    setLoading(true);
    loadRecruits();
    return () => { activeRef.current = false; };
  }, [loadRecruits]));
  const onRefresh = async () => { setRefreshing(true); await loadRecruits(); setRefreshing(false); };

  const isExpired = (r) => {
    if (!r.scheduledDate) return false;
    const base = new Date(r.scheduledDate);
    if (r.scheduledTimeEnd) { const [h,m] = r.scheduledTimeEnd.split(':').map(Number); base.setHours(h,m,0,0); }
    else if (r.scheduledTime) { const [h,m] = r.scheduledTime.split(':').map(Number); base.setHours(h+2,m,0,0); }
    else base.setHours(23,59,59,999);
    return base < new Date();
  };
  const isClosed = (r) => r.status === 'closed' || ((r.currentSlots||1) >= r.totalSlots && r.status === 'full');

  // 80차 계속: [버그 수정, 안전] 차단(blockedUsers)이 댓글/대댓글/크루 게시판엔 이미
  // 적용돼 있는데 모집글 목록 자체엔 전혀 안 걸려있었음(fork 감사로 발견) — 낯선 사람과
  // 만나는 접점인 모집글이 정작 커버리지가 빠진 사각지대. 목록/추천 스트립 둘 다 이
  // 필터링된 배열을 공유.
  const blockedUsers = profile?.blockedUsers || [];
  const visibleRecruits = blockedUsers.length ? recruits.filter(r => !blockedUsers.includes(r.uid)) : recruits;

  const filtered = visibleRecruits.filter(r => {
    // 78차: mineOnly(내 모집 관리)일 때는 마감/기한지남도 내 이력이면 계속 보여줌
    // (라벨이 "현황"이라 진행중인 것만 보이면 오히려 History가 사라진 것처럼 보임)
    if (mineOnly) {
      const isMine = user && (r.uid === user.uid || r.participants?.includes(user.uid) || r.pendingParticipants?.includes(user.uid));
      if (!isMine) return false;
    } else if (isClosed(r) || isExpired(r)) return false;
    const regionOk     = filterRegion === '전체' || (
                            (r.region && r.region.includes(filterRegion)) &&
                            (filterSubRegion === '전체' || (r.region && r.region.includes(filterSubRegion)))
                          );
    const genreOk      = filterGenre      === '전체' || (r.genres && r.genres.includes(filterGenre)) || r.genre === filterGenre;
    const difficultyOk = filterDifficulty === '전체' || r.difficulty === filterDifficulty;
    const formatOk      = filterFormat === '전체' || (r.bookingFormat || 'room') === filterFormat;
    const availableOk  = !onlyAvailable   || (r.totalSlots - (r.currentSlots||1)) > 0;
    const q = searchQuery.trim().toLowerCase();
    const searchOk = !q ||
      (r.title && r.title.toLowerCase().includes(q)) ||
      (r.productName && r.productName.toLowerCase().includes(q)) ||
      (r.storeName && r.storeName.toLowerCase().includes(q)) ||
      (r.authorName && r.authorName.toLowerCase().includes(q));
    return regionOk && genreOk && difficultyOk && formatOk && availableOk && searchOk;
  });
  // 74차: 초기화 버튼을 필터 활성 여부에 따라 조건부로 렌더링/제거하던 것 → 위치 고정,
  // 활성 여부만 바뀌도록 변경 (필터 걸 때마다 "작성" 버튼 옆에 X가 툭 튀어나오던 어색함 해결)
  const hasActiveFilter = filterRegion !== '전체' || filterSubRegion !== '전체' || filterGenre !== '전체' || filterDifficulty !== '전체' || filterFormat !== 'room' || onlyAvailable;
  const resetFilters = () => { setFilterRegion('전체'); setFilterSubRegion('전체'); setFilterGenre('전체'); setFilterDifficulty('전체'); setFilterFormat('room'); setOnlyAvailable(false); };

  const getDDay = (r) => {
    if (!r.scheduledDate) return null;
    const today = new Date(); today.setHours(0,0,0,0);
    const target = new Date(r.scheduledDate); target.setHours(0,0,0,0);
    const diff = Math.round((target - today) / (1000*60*60*24));
    if (diff < 0) return null;
    if (diff === 0) return { label:'D-Day', urgent:true };
    if (diff <= 3)  return { label:`D-${diff}`, urgent:true };
    return { label:`D-${diff}`, urgent:false };
  };

  // 80차 계속: "나와 잘 맞는 모집" — 카드 JSX를 renderCard로 추출(기존엔 filtered.map
  // 안에 인라인이었음). 메인 목록과 아래 추천 가로스크롤 둘 다 이 함수 하나를 공유해
  // ~80줄짜리 카드 마크업을 중복 작성하지 않음.
  const renderCard = (r) => {
    const isMine       = user && r.uid === user.uid;
    const isJoined     = user && r.participants?.includes(user.uid);
    const isPending    = user && r.pendingParticipants?.includes(user.uid);
    const pendingCount = isMine ? (r.pendingParticipants?.length || 0) : 0;
    const remaining    = r.totalSlots - (r.currentSlots || 1);
    const dDay         = getDDay(r);
    const now          = Date.now();
    const isBoosted    = r.boostedUntil
      ? (typeof r.boostedUntil.toMillis==='function' ? r.boostedUntil.toMillis()>now : new Date(r.boostedUntil).getTime()>now)
      : false;
    const dateLabel = r.scheduledDate
      ? new Date(r.scheduledDate).toLocaleDateString('ko-KR', { month:'long', day:'numeric' })
      : null;
    return (
      <TouchableOpacity key={r.id} activeOpacity={0.85}
        style={[s.card, isBoosted && s.cardBoosted]}
        onPress={() => { setShowRegionPicker(false); setShowGenrePicker(false); navigation.navigate('RecruitDetail', { recruitId: r.id }); }}>
        <View style={s.cardRow}>
          <View style={s.thumbWrap}>
            {r.imageUrl
              ? <Image source={{ uri:r.imageUrl }} style={s.thumb} contentFit="cover" />
              : <View style={[s.thumb, s.thumbPlaceholder]}>
                  <Text style={s.thumbPlaceholderText}>{(r.productName||r.title||'?')[0]}</Text>
                </View>}
            {isBoosted && <View style={s.thumbBoostDot}><StarIcon size={10} filled color="#241a06" /></View>}
            {isMine && pendingCount>0 && <View style={s.thumbPendingDot}><Text style={s.thumbPendingDotTxt}>{pendingCount}</Text></View>}
          </View>
          <View style={s.cardBody}>
            <View style={s.badgeRow}>
              <Badge label={r.bookingFormat === 'show' ? '체험형' : '방탈출'} color={r.bookingFormat === 'show' ? C.info : C.success} />
              {r.isAdultOnly && <Badge label="19금" color={C.danger} />}
              {(r.genres?.[0]||r.genre) && <Badge label={r.genres?.[0]||r.genre} color={C.gold} />}
              {r.region && <Badge label={r.region} color={C.warning} />}
              {dDay && <DDayBadge label={dDay.label} urgent={dDay.urgent} />}
              {isMine && <Badge label="내 글" color={C.info} />}
              {isPending && <Badge label="신청중" color={C.warning} />}
              {isJoined && !isMine && <Badge label="참가중" color={C.gold} />}
            </View>
            <Text style={s.cardTitle} numberOfLines={1}>{r.title}</Text>
            <View style={{ flexDirection:'row', alignItems:'center', gap:6, flexShrink:1 }}>
              <IconLabel Icon={MenuEscapeIcon} size={11} color={C.muted} gap={3} textStyle={s.cardSub} numberOfLines={1} style={{ flexShrink:1 }}>
                {r.productName||'테마 미정'}
              </IconLabel>
              {dateLabel && (
                <IconLabel Icon={CalendarCheckIcon} size={11} color={C.muted} gap={3} textStyle={s.cardSub} numberOfLines={1}>
                  {dateLabel}{r.scheduledTime ? ` ${r.scheduledTime}` : ''}
                </IconLabel>
              )}
            </View>
            <View style={s.cardBottomRow}>
              <View style={{ flexDirection:'row', alignItems:'center', gap:6, flexShrink:1 }}>
                <IconLabel Icon={PeopleIcon} size={11} color={C.textSec} gap={3} textStyle={s.metaTxt} numberOfLines={1}>
                  {remaining>0 ? `잔여 ${remaining}자리` : '마감'} ({r.currentSlots||1}/{r.totalSlots})
                </IconLabel>
                {r.viewCount>0 && (
                  <IconLabel Icon={ViewsIcon} size={11} color={C.textSec} gap={3} textStyle={s.metaTxt} numberOfLines={1}>
                    {String(r.viewCount)}
                  </IconLabel>
                )}
                {(r.pendingParticipants?.length || 0) > 0 && (
                  <IconLabel Icon={TrendingUpIcon} size={11} color={C.gold} gap={3} textStyle={[s.metaTxt, { color:C.gold, fontWeight:'700' }]} numberOfLines={1}>
                    {r.pendingParticipants.length}명 신청중
                  </IconLabel>
                )}
              </View>
              {isMine ? (
                <Text style={s.cardFooterTxt} numberOfLines={1}>관리 →</Text>
              ) : isPending ? (
                <IconLabel Icon={HourglassIcon} size={11} color={C.gold} gap={3} textStyle={s.cardFooterTxt} numberOfLines={1}>대기중</IconLabel>
              ) : (
                <Text style={s.cardFooterTxt} numberOfLines={1}>신청하기 →</Text>
              )}
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  // 80차 계속: 본인 favoriteGenre와 겹치는 모집글(내 글/이미 참여·신청/마감 제외) —
  // 최대 8개, 최신순. recruits(원본, 필터 무관) 기준이라 사용자가 필터를 걸어도
  // 추천 스트립 자체는 그대로 유지됨.
  const recommended = favoriteGenre
    ? visibleRecruits.filter(r => {
        if (r.uid === user?.uid) return false;
        if (user && (r.participants?.includes(user.uid) || r.pendingParticipants?.includes(user.uid))) return false;
        if ((r.totalSlots - (r.currentSlots||1)) <= 0 && !r.openSeatUid) return false;
        return r.genres?.includes(favoriteGenre) || splitGenres(r.genre).includes(favoriteGenre);
      }).slice(0, 8)
    : [];

  // 74차: 비회원 전체 차단 화면 제거 — 조회는 자유, 참여/작성 시점에만 로그인 유도
  // (RecruitDetailScreen.js / RecruitWriteGuard가 각자 이미 그렇게 처리하고 있음)

  if (loading || authLoading) return (
    <View style={s.container}>
      <AppHeader
        showBack={showBack}
        centerElement={showBack ? <Text style={{ color: C.text, fontSize: 15, fontWeight: '800' }}>내 모집 관리</Text> : undefined}
      />
      <View style={{ flex: 1, justifyContent:'center', alignItems:'center' }}>
        <ActivityIndicator size="large" color={C.gold} />
      </View>
    </View>
  );

  return (
    <View style={s.container}>
      <AppHeader
        showBack={showBack}
        centerElement={showBack ? <Text style={{ color: C.text, fontSize: 15, fontWeight: '800' }}>내 모집 관리</Text> : undefined}
        rightElement={!showBack && isLoggedIn ? (
          <TouchableOpacity
            onPress={() => setShowNotifyModal(true)}
            accessibilityLabel="관심 지역·장르 알림 설정"
            style={{ padding: 6 }}>
            <MenuBellIcon size={20} color={(notifyRegion || notifyGenre) ? C.gold : C.muted} />
          </TouchableOpacity>
        ) : undefined}
      />
      <NotifyPrefsModal
        visible={showNotifyModal}
        onClose={() => setShowNotifyModal(false)}
        region={notifyRegion}
        genre={notifyGenre}
        onSave={async (region, genre) => {
          try {
            await updateDoc(doc(db, 'users', user.uid), {
              notifyRecruitRegion: region, notifyRecruitGenre: genre,
            });
            setNotifyRegion(region);
            setNotifyGenre(genre);
            setShowNotifyModal(false);
          } catch {
            showAlert('오류', '저장에 실패했습니다.');
          }
        }}
      />

      <View style={s.searchRow}>
        <View style={s.searchInputWrap}>
          <TextInput
            style={s.searchInput} value={searchQuery} onChangeText={setSearchQuery}
            placeholder="제목, 테마명, 매장명, 작성자 검색..." placeholderTextColor={C.muted}
            returnKeyType="search"
            onFocus={() => { setShowRegionPicker(false); setShowGenrePicker(false); setShowDifficultyPicker(false); setShowFormatPicker(false); }}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity style={s.searchClear} onPress={() => setSearchQuery('')} accessibilityLabel="검색어 지우기">
              <CancelIcon size={16} color={C.muted} />
            </TouchableOpacity>
          )}
        </View>
        <TouchableOpacity onPress={() => navigation.navigate('RecruitWrite')} activeOpacity={0.85}>
          <LinearGradient colors={GRADIENTS.button} start={{x:0,y:0}} end={{x:1,y:1}} style={s.writeTabBtn}>
            <IconLabel Icon={EditIcon} size={12} color={ON_GOLD} textStyle={s.writeTabBtnTxt}>작성</IconLabel>
          </LinearGradient>
        </TouchableOpacity>
      </View>

      <View style={s.filterRow}>
        {/* 오늘 fork 재검토(다양한 기기 UI 겹침 확인)로 발견: 4개 필터 버튼을 flex:1로
            균등분배하면 좁은 화면(360dp 등)에서 라벨이 "지...", "장..."처럼 전부
            잘림 — 78차18차에 매장설정 4버튼 행을 고친 것과 동일한 유형·동일한 해결책
            (가로 스크롤 + 라벨 길이만큼 자기 폭을 갖는 방식)으로 교체. */}
        {/* 오늘 fork 재검토(전체 정독)로 발견/수정: 위 교체 직후엔 각 버튼의 드롭다운을
            그 버튼과 같은 ScrollView 안에 absolute로 얹어뒀는데, absolute 자식은
            ScrollView의 콘텐츠 높이 계산에 안 들어가서 ScrollView 자체 높이가 버튼
            높이(~40px)에 고정돼 버려 드롭다운이 그 아래로 전부 잘려 사실상 안 보이고
            탭도 안 되는 상태였음 — 드롭다운 4개를 전부 ScrollView 밖으로 빼서
            filterRow 아래에 전체 폭 패널(펼침형, absolute 아님)로 렌더링하도록 재구성. */}
        {/* 80차 계속: [순서 변경] 형식(전체/방탈출/체험형, 기본값 방탈출) → 지역 → 장르 →
            난이도 순으로 재배치(요청) — 실사용 모집글 대부분이 방탈출이라 형식 필터를
            맨 앞에 두고 기본값도 방탈출로 좁혀서 처음 진입 화면이 더 예측 가능하게 함. */}
        <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ flex:1 }} contentContainerStyle={{ flexDirection:'row', gap:8 }}>
          <TouchableOpacity style={s.filterBtn} onPress={() => { setShowFormatPicker(p=>!p); setShowRegionPicker(false); setShowGenrePicker(false); setShowDifficultyPicker(false); }}>
            <IconLabel Icon={MenuEscapeIcon} size={12} color={C.textSec} textStyle={s.filterBtnTxt} numberOfLines={1}>
              {FORMATS.find(f => f.value === filterFormat)?.label} ▾
            </IconLabel>
          </TouchableOpacity>
          <TouchableOpacity style={s.filterBtn} onPress={() => { setShowRegionPicker(p=>!p); setShowGenrePicker(false); setShowDifficultyPicker(false); setShowFormatPicker(false); }}>
            <IconLabel Icon={LocationIcon} size={12} color={C.textSec} textStyle={s.filterBtnTxt} numberOfLines={1}>
              {filterRegion === '전체' ? '지역' : filterSubRegion !== '전체' ? `${filterRegion} ${filterSubRegion}` : filterRegion} ▾
            </IconLabel>
          </TouchableOpacity>
          <TouchableOpacity style={s.filterBtn} onPress={() => { setShowGenrePicker(p=>!p); setShowRegionPicker(false); setShowDifficultyPicker(false); setShowFormatPicker(false); }}>
            <IconLabel Icon={GenreIcon} size={12} color={C.textSec} textStyle={s.filterBtnTxt} numberOfLines={1}>{filterGenre === '전체' ? '장르' : filterGenre} ▾</IconLabel>
          </TouchableOpacity>
          <TouchableOpacity style={s.filterBtn} onPress={() => { setShowDifficultyPicker(p=>!p); setShowRegionPicker(false); setShowGenrePicker(false); setShowFormatPicker(false); }}>
            <IconLabel Icon={RecruitDifficultyGaugeIcon} size={12} color={C.textSec} textStyle={s.filterBtnTxt} numberOfLines={1}>{filterDifficulty === '전체' ? '난이도' : difficultyLabelFor(filterDifficulty)} ▾</IconLabel>
          </TouchableOpacity>
        </ScrollView>
        {/* 74차: 조건부 렌더링(등장/소실) 대신 위치 고정 + 활성 상태만 토글 */}
        <TouchableOpacity
          style={[s.resetBtn, !hasActiveFilter && s.resetBtnDisabled]}
          onPress={resetFilters}
          disabled={!hasActiveFilter}>
          <Text style={[s.resetBtnTxt, !hasActiveFilter && s.resetBtnTxtDisabled]}>↺ 초기화</Text>
        </TouchableOpacity>
      </View>

      {/* 80차 계속: [크기 축소] 지역/장르 선택지가 늘어나면서(특히 지역 18개+서울
          상세지역 24개) 드롭다운이 펼쳐질 때마다 그 아래 모집글 목록이 화면 밖으로
          쭉 밀려나던 문제 — 절대위치 오버레이는 78차 fork 재검토 때 이미 한 번 시도해
          ScrollView 콘텐츠 높이 계산이 깨지는 버그로 되돌린 전례가 있어(위 주석 참고)
          다시 시도하지 않고, 대신 패널 자체의 최대 높이를 큰 폭으로 줄여 3~5개 정도만
          보이고 나머지는 스크롤하도록 함 — 목록이 밀려나는 폭 자체가 훨씬 작아짐.
          버튼 순서(형식→지역→장르→난이도)와 동일한 순서로 패널도 재배치. */}
      {showFormatPicker && (
        <View style={s.dropdownPanel}>
          {FORMATS.map(f => (
            <TouchableOpacity key={f.value} style={s.dropdownItem} onPress={() => { setFilterFormat(f.value); setShowFormatPicker(false); }}>
              <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
                {filterFormat===f.value && <CheckmarkIcon size={11} color={C.gold} />}
                <Text style={[s.dropdownTxt, filterFormat===f.value && { color:C.gold, fontWeight:'700' }]}>{f.label}</Text>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      )}
      {showRegionPicker && (
        <View style={s.dropdownPanel}>
          <ScrollView style={{ maxHeight:170 }} nestedScrollEnabled>
            {REGIONS.map(r => (
              <TouchableOpacity key={r} style={s.dropdownItem}
                onPress={() => {
                  setFilterRegion(r);
                  setFilterSubRegion('전체');
                  // 75차: 구/동 목록이 있는 지역이면 드롭다운을 안 닫고 아래 목록을 보여줌
                  if (r === '전체' || !(SUB_REGIONS[r]?.length > 0)) setShowRegionPicker(false);
                }}>
                <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
                  {filterRegion===r && <CheckmarkIcon size={11} color={C.gold} />}
                  <Text style={[s.dropdownTxt, filterRegion===r && { color:C.gold, fontWeight:'700' }]}>{r}</Text>
                </View>
              </TouchableOpacity>
            ))}
            {/* 75차: 선택한 지역의 구/동 단위 필터 — 글 작성 시 이미 저장되는 상세지역
                (RecruitWriteScreen.js)을 필터에서도 고를 수 있게 함 */}
            {filterRegion !== '전체' && SUB_REGIONS[filterRegion]?.length > 0 && (
              <View style={s.subRegionBox}>
                <Text style={s.subRegionLabel}>{filterRegion} 상세지역</Text>
                <View style={{ flexDirection:'row', flexWrap:'wrap', gap:6 }}>
                  <TouchableOpacity
                    style={[s.subRegionChip, filterSubRegion==='전체' && s.subRegionChipOn]}
                    onPress={() => { setFilterSubRegion('전체'); setShowRegionPicker(false); }}>
                    <Text style={[s.subRegionChipTxt, filterSubRegion==='전체' && s.subRegionChipTxtOn]}>전체</Text>
                  </TouchableOpacity>
                  {SUB_REGIONS[filterRegion].map(sr => (
                    <TouchableOpacity key={sr}
                      style={[s.subRegionChip, filterSubRegion===sr && s.subRegionChipOn]}
                      onPress={() => { setFilterSubRegion(sr); setShowRegionPicker(false); }}>
                      <Text style={[s.subRegionChipTxt, filterSubRegion===sr && s.subRegionChipTxtOn]}>{sr}</Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </View>
            )}
          </ScrollView>
        </View>
      )}
      {showGenrePicker && (
        <View style={s.dropdownPanel}>
          <ScrollView style={{ maxHeight:170 }} nestedScrollEnabled>
            {GENRES.map(g => (
              <TouchableOpacity key={g} style={s.dropdownItem} onPress={() => { setFilterGenre(g); setShowGenrePicker(false); }}>
                <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
                  {filterGenre===g && <CheckmarkIcon size={11} color={C.gold} />}
                  <Text style={[s.dropdownTxt, filterGenre===g && { color:C.gold, fontWeight:'700' }]}>{g}</Text>
                </View>
              </TouchableOpacity>
            ))}
          </ScrollView>
        </View>
      )}
      {showDifficultyPicker && (
        <View style={s.dropdownPanel}>
          <ScrollView style={{ maxHeight:170 }} nestedScrollEnabled>
            {DIFFICULTIES.map(d => (
              <TouchableOpacity key={d} style={s.dropdownItem} onPress={() => { setFilterDifficulty(d); setShowDifficultyPicker(false); }}>
                <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
                  {filterDifficulty===d && <CheckmarkIcon size={11} color={C.gold} />}
                  <Text style={[s.dropdownTxt, filterDifficulty===d && { color:C.gold, fontWeight:'700' }]}>{difficultyLabelFor(d)}</Text>
                </View>
              </TouchableOpacity>
            ))}
          </ScrollView>
        </View>
      )}

      <View style={s.subFilterRow}>
        <TouchableOpacity onPress={() => setOnlyAvailable(p=>!p)} activeOpacity={0.85}>
          {onlyAvailable ? (
            <LinearGradient colors={GRADIENTS.button} start={{x:0,y:0}} end={{x:1,y:1}} style={s.availableToggle}>
              <IconLabel Icon={CheckmarkIcon} size={12} color={ON_GOLD} textStyle={[s.availableToggleTxt, { color:ON_GOLD }]}>빈자리만</IconLabel>
            </LinearGradient>
          ) : (
            <View style={s.availableToggle}>
              <Text style={s.availableToggleTxt}>빈자리만</Text>
            </View>
          )}
        </TouchableOpacity>
        <Text style={s.resultCount}>총 {filtered.length}건</Text>
      </View>

      {/* 80차 계속: [순서 재조정, 실기기 신고 2회로 확정] 1차 시도(검색창 바로 아래로
          이동)는 필터보다 카드가 먼저 나와 오히려 더 어색해졌음(사용자 재신고) — 필터
          관련 UI(filterRow+subFilterRow)를 전부 묶어 먼저 보여주고, 그 다음에 개인화
          추천 카드, 그 다음에 실제 목록이 나오는 순서로 최종 확정. 추천 자체는 여전히
          filtered와 무관하게 항상 같은 내용을 보여줌(위치만 필터 뒤·목록 앞으로). */}
      {recommended.length > 0 && (
        <View style={s.recoSection}>
          <View style={{ flexDirection:'row', alignItems:'center', gap:4, paddingHorizontal:14, marginBottom:8 }}>
            <TrendingUpIcon size={13} color={C.gold} />
            <Text style={s.recoTitle}>나와 잘 맞는 모집 · {favoriteGenre}</Text>
          </View>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingHorizontal:14, gap:10 }}>
            {recommended.map(r => <View key={r.id} style={{ width: width - 48 }}>{renderCard(r)}</View>)}
          </ScrollView>
        </View>
      )}

      {/* 78차 35차: 필터 드롭다운이 열린 상태에서 목록 영역(카드/빈공간)을 탭해도
          안 닫히던 것 — 목록 영역 전체를 덮는 투명 오버레이로 바깥 탭 감지 추가.
          기존 onScrollBeginDrag(드래그로 닫힘)는 그대로 유지, 이건 "탭만" 하는
          케이스를 보완 */}
      <View style={{ flex:1, position:'relative' }}>
      <ScrollView
        style={s.body}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={C.gold} />}
        onScrollBeginDrag={() => { setShowRegionPicker(false); setShowGenrePicker(false); setShowDifficultyPicker(false); setShowFormatPicker(false); }}>

        {filtered.length === 0 ? (
          <View style={s.empty}>
            <View style={{ marginBottom:12 }}><EmptySearchResultIcon size={64} /></View>
            <Text style={s.emptyTxt}>{mineOnly ? '내가 쓰거나 참여한 모집이 없습니다' : '현재 모집 중인 글이 없습니다'}</Text>
            <TouchableOpacity style={[s.filterBtn, { marginTop:20, paddingHorizontal:24, borderColor:C.goldBdr }]} onPress={() => navigation.navigate('RecruitWrite')}>
              <Text style={[s.filterBtnTxt, { color:C.gold }]}>첫 모집 글 작성하기</Text>
            </TouchableOpacity>
          </View>
        ) : (
          filtered.map(renderCard)
        )}
        <View style={{ height:60 }} />
      </ScrollView>
      {(showRegionPicker || showGenrePicker || showDifficultyPicker || showFormatPicker) && (
        <Pressable
          style={StyleSheet.absoluteFill}
          onPress={() => { setShowRegionPicker(false); setShowGenrePicker(false); setShowDifficultyPicker(false); setShowFormatPicker(false); }}
        />
      )}
      </View>
    </View>
  );
}

// 80차 계속: 관심 지역·장르 알림 설정 모달 — 위 필터 드롭다운과 동일한 REGIONS/GENRES
// 목록을 재사용하되, 별도 상태(필터를 건드리지 않음)로 독립. '전체'를 고르면 그
// 축(지역 또는 장르)은 알림 조건에서 제외(null)하는 것으로 취급.
function NotifyPrefsModal({ visible, onClose, region, genre, onSave }) {
  const [localRegion, setLocalRegion] = useState(region || '전체');
  const [localGenre,  setLocalGenre]  = useState(genre || '전체');

  React.useEffect(() => {
    if (visible) { setLocalRegion(region || '전체'); setLocalGenre(genre || '전체'); }
  }, [visible, region, genre]);

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <Pressable style={npm.overlay} onPress={onClose}>
        <Pressable style={npm.sheet} onPress={() => {}}>
          <Text style={npm.title}>관심 지역·장르 알림</Text>
          <Text style={npm.desc}>선택한 지역+장르와 맞는 새 모집글이 올라오면 알려드려요.</Text>

          <Text style={npm.label}>지역</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 14 }}>
            <View style={{ flexDirection: 'row', gap: 6 }}>
              {['전체', ...MASTER_REGIONS].map(r => (
                <TouchableOpacity key={r}
                  style={[npm.chip, localRegion === r && npm.chipOn]}
                  onPress={() => setLocalRegion(r)}>
                  <Text style={[npm.chipTxt, localRegion === r && npm.chipTxtOn]}>{r}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>

          <Text style={npm.label}>장르</Text>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ marginBottom: 18 }}>
            <View style={{ flexDirection: 'row', gap: 6 }}>
              {['전체', ...MASTER_GENRES].map(g => (
                <TouchableOpacity key={g}
                  style={[npm.chip, localGenre === g && npm.chipOn]}
                  onPress={() => setLocalGenre(g)}>
                  <Text style={[npm.chipTxt, localGenre === g && npm.chipTxtOn]}>{g}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>

          <View style={{ flexDirection: 'row', gap: 8 }}>
            {(region || genre) && (
              <TouchableOpacity style={npm.offBtn} onPress={() => onSave(null, null)}>
                <Text style={npm.offBtnTxt}>알림 끄기</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity
              style={npm.saveBtn}
              onPress={() => onSave(
                localRegion === '전체' ? null : localRegion,
                localGenre === '전체' ? null : localGenre,
              )}>
              <Text style={npm.saveBtnTxt}>저장</Text>
            </TouchableOpacity>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const npm = StyleSheet.create({
  overlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.6)', justifyContent: 'flex-end' },
  sheet:   { backgroundColor: C.surface, borderTopLeftRadius: 20, borderTopRightRadius: 20,
             padding: 20, paddingBottom: 32 },
  title:   { color: C.text, fontSize: 16, fontWeight: '800', marginBottom: 4 },
  desc:    { color: C.muted, fontSize: 12.5, marginBottom: 16, lineHeight: 18 },
  label:   { color: C.textSec, fontSize: 12, fontWeight: '700', marginBottom: 8 },
  chip:    { paddingHorizontal: 12, paddingVertical: 7, borderRadius: 999,
             borderWidth: 1, borderColor: C.border, backgroundColor: C.card },
  chipOn:  { borderColor: C.gold, backgroundColor: C.gold + '18' },
  chipTxt: { color: C.textSec, fontSize: 12.5, fontWeight: '600' },
  chipTxtOn: { color: C.gold },
  saveBtn: { flex: 1, backgroundColor: C.gold, borderRadius: 12, paddingVertical: 13, alignItems: 'center' },
  saveBtnTxt: { color: '#241a06', fontSize: 14, fontWeight: '800' },
  offBtn:  { paddingHorizontal: 16, borderRadius: 12, paddingVertical: 13, alignItems: 'center',
             borderWidth: 1, borderColor: COLORS.red + '50', backgroundColor: COLORS.red + '10' },
  offBtnTxt: { color: COLORS.red, fontSize: 13, fontWeight: '700' },
});

const s = StyleSheet.create({
  container:      { flex:1, backgroundColor:C.bg },
  // 74차: 검색창 행에 "작성" 버튼을 같이 둠(기존엔 필터 행 끝에 있어서 필터 초기화
  // 버튼이 조건부로 등장/소실할 때마다 작성 버튼이 좌우로 밀리는 것처럼 보였음)
  searchRow:      { flexDirection:'row', alignItems:'center', gap:8, backgroundColor:C.surface, paddingHorizontal:12, paddingVertical:8, borderBottomWidth:1, borderBottomColor:C.border },
  // 78차 35차: 검색창(paddingVertical 기반 가변 높이)이 옆 "작성" 버튼(고정 height:38)과
  // 높이가 안 맞아 보이던 것 — 검색창도 동일한 고정 높이로 맞춤
  searchInputWrap:{ flex:1, height:38, flexDirection:'row', alignItems:'center', backgroundColor:C.card, borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.border },
  searchInput:    { flex:1, height:'100%', paddingHorizontal:12, paddingVertical:0, color:C.text, fontSize:13 },
  searchClear:    { paddingHorizontal:8, paddingVertical:8 },
  filterRow:      { flexDirection:'row', padding:10, gap:8, alignItems:'center', backgroundColor:C.surface, borderBottomWidth:1, borderBottomColor:C.border },
  // 80차 후속: [버그 수정, 실기기 신고] IconLabel에 numberOfLines가 없어 좁은 화면(폭이
  // 좁은 안드로이드 기기)에서 "지역"/"장르" 등 2~3자 라벨도 줄바꿈되는데, 부모가 height
  // 고정(넘치면 잘림)이라 글자가 위아래로 잘려 보였음 — numberOfLines={1}(호출부에 추가) +
  // minHeight로 전환, paddingHorizontal도 좁혀 좁은 화면에서 텍스트가 더 잘 들어가게 함.
  filterBtn:      { borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.border, backgroundColor:C.card, minHeight:38, minWidth:64, paddingHorizontal:8, paddingVertical:4, alignItems:'center', justifyContent:'center' },
  filterBtnTxt:   { color:C.textSec, fontSize:12, fontWeight:'600' },
  // 오늘 fork 재검토로 발견/수정: 필터 버튼이 가로 스크롤로 바뀌면서, absolute로 버튼
  // 바로 아래에 얹던 기존 dropdown 방식은 ScrollView 안에 있으면 콘텐츠 높이 계산에
  // 안 잡혀 통째로 잘려 보이지 않게 됨 — 버튼 그룹(ScrollView) 밖, filterRow 바로
  // 아래에 카드 목록 전 폭을 쓰는 펼침형 패널로 전환(absolute 아님, 일반 문서 흐름).
  dropdownPanel:  { marginHorizontal:10, marginTop:-2, marginBottom:8, backgroundColor:C.card, borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.border, ...SHADOW.card },
  dropdownItem:   { paddingVertical:10, paddingHorizontal:14 },
  dropdownTxt:    { color:C.textSec, fontSize:13 },
  subRegionBox:      { padding:12, borderTopWidth:1, borderTopColor:C.border },
  subRegionLabel:    { color:C.muted, fontSize:11, fontWeight:'700', marginBottom:8 },
  subRegionChip:     { paddingHorizontal:10, paddingVertical:6, borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.border, backgroundColor:C.card },
  subRegionChipOn:   { backgroundColor:C.gold+'22', borderColor:C.gold },
  subRegionChipTxt:  { color:C.textSec, fontSize:12 },
  subRegionChipTxtOn:{ color:C.gold, fontWeight:'700' },
  resetBtn:       { borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.danger, backgroundColor:C.card, height:38, paddingHorizontal:12, alignItems:'center', justifyContent:'center' },
  resetBtnTxt:    { color:C.danger, fontSize:12, fontWeight:'700' },
  // 74차: 필터 없을 때는 위치는 유지한 채 흐리게(비활성) 표시 — 등장/소실 대신 상태만 전환
  resetBtnDisabled:   { borderColor:C.border, opacity:0.4 },
  resetBtnTxtDisabled:{ color:C.muted },
  writeTabBtn:    { height:38, paddingHorizontal:14, borderRadius:10, alignItems:'center', justifyContent:'center' },
  writeTabBtnTxt: { color:ON_GOLD, fontWeight:'700', fontSize:12 },
  subFilterRow:   { flexDirection:'row', alignItems:'center', justifyContent:'space-between', paddingHorizontal:14, paddingVertical:8, borderBottomWidth:1, borderBottomColor:C.border },
  recoSection:    { paddingTop:10, borderBottomWidth:1, borderBottomColor:C.border },
  recoTitle:      { fontSize:13, fontWeight:'700', color:C.text },
  availableToggle:    { flexDirection:'row', alignItems:'center', borderRadius:999, borderWidth:1, borderColor:C.border, paddingHorizontal:12, paddingVertical:6, backgroundColor:C.card },
  availableToggleTxt: { color:C.muted, fontSize:12, fontWeight:'600' },
  resultCount:    { color:C.muted, fontSize:12 },
  body:           { flex:1, padding:14 },
  card:           { backgroundColor:C.card, borderRadius:14, borderWidth:1, borderColor:C.border, marginBottom:10, overflow:'hidden', ...SHADOW.card },
  cardBoosted:    { borderColor:C.goldBdr, borderWidth:1.5 },
  cardRow:        { flexDirection:'row', padding:10, gap:10 },
  thumbWrap:      { position:'relative' },
  thumb:          { width:76, height:76, borderRadius:10 },
  thumbPlaceholder:{ backgroundColor:'rgba(212,168,67,0.06)', alignItems:'center', justifyContent:'center' },
  thumbPlaceholderText:{ fontSize:28, color:C.gold, fontWeight:'900', opacity:0.35 },
  thumbBoostDot:      { position:'absolute', top:-4, left:-4, backgroundColor:'rgba(212,168,67,0.95)', borderRadius:9, width:18, height:18, alignItems:'center', justifyContent:'center' },
  thumbBoostDotTxt:   { fontSize:10 },
  thumbPendingDot:    { position:'absolute', top:-4, right:-4, backgroundColor:C.danger, borderRadius:9, minWidth:18, height:18, paddingHorizontal:3, alignItems:'center', justifyContent:'center' },
  thumbPendingDotTxt: { color:'#fff', fontSize:10, fontWeight:'900' },
  cardBody:    { flex:1, justifyContent:'center', gap:4 },
  badgeRow:    { flexDirection:'row', flexWrap:'wrap', gap:5, alignItems:'center' },
  cardTitle:   { fontSize:15, fontWeight:'700', color:C.text },
  cardSub:     { fontSize:12, color:C.muted },
  cardBottomRow: { flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginTop:2 },
  metaTxt:     { fontSize:11, color:C.textSec, flexShrink:1 },
  cardFooterTxt:{ color:C.gold, fontSize:11, fontWeight:'600' },
  empty:       { alignItems:'center', paddingTop:80 },
  emptyTxt:    { color:C.muted, fontSize:13 },
});